import MyInvoicesPage from './MyInvoicesPage'

export default MyInvoicesPage
